import { SSHOperationConstant } from './Constants';
const SSHPopHelper = {};
/**
 * 默认内容居中显示
 * 改为靠左显示
 * @return {{style: string}}
 */
const getClass = () => ({ style: 'text-align: left; word-break: break-all' });

const jcAlertClass = () => ({
  style: '' +
  ' width: 100%;' +
  'padding: 5px 8px;' +
  'margin: 0 0 20px;' +
  'box-sizing: border-box;' +
  'border-radius: 0;' +
  'position: relative;' +
  'background-color: #ffe5e5;' +
  'overflow: hidden;' +
  'opacity: 1;' +
  'display: table;' +
  'transition: opacity .2s;' +
  'border-width: 1px;' +
  'border-style: solid;' +
  'min-height: 30px;' +
  'border-color: #ff3a3a;' +
  'color: #ff3a3a;'
})

export function operations(caseOps, target, param, type) {
  switch (parseInt(caseOps)) {
    // 删除SSH操作
    case SSHOperationConstant.DELETE:
      const h = target.$createElement;
      const params = {
        region: param.region,
        keypairId: param.keypairId
      };
      target.$msgbox({
        customClass: 'width-larger',
        title: target.$t('ssh.help.deleteKey'),
        message: h('p', getClass(), [
          h('span', jcAlertClass(), target.$t('ssh.help.deleteKeyTip')),
          h('br', null),
          h('br', null),
          h('span', null, target.$t('ssh.help.confirmToDelete', [param.name])),
        ]),
        closeOnClickModal: false,
        showCancelButton: true,
        confirmButtonText: target.$t('popHelper.text.sure'),
        cancelButtonText: target.$t('popHelper.text.cancel'),
      }).then(() => {
        Ajax.del('/api/cps/keypairs', params)
          .then(() => {
            // 根据当前页面类型决定删除后动作
            switch (type) {
              // 列表页删除之后刷新页面
              case 'list': {
                target.updateList('refresh');
                break;
              }
              // 详情页删除之后跳转到列表页
              case 'detail': {
                target.$router.push('/ssh/list');
                break;
              }
            }
          })
          .catch(async (err) => {
            const { response } = err.data;
            try {
              const json = await response.json();
              target.$message.error(json.errmsg);
            } catch (ex) {
              console.log(ex);
            }
          })
          .finally(() => {
          });
      });
  }
}

export function alert(target){
  const h = target.$createElement;
  target.$msgbox({
    title: target.$t('create.text.info'),
    message: h('p', getClass(), [
      h('span', null, target.$t('ssh.help.successAlert')),
    ]),
    closeOnClickModal: false,
    showCancelButton: false,
    confirmButtonText: target.$t('popHelper.text.sure'),
  })
}

export default SSHPopHelper;



// WEBPACK FOOTER //
// ./src/common/SSHPopHelper.js